import createVueApp from '@phoenix/createVueApp';
import { PhxToaster } from '@maison/Toolkit';

const app = createVueApp();
app.component('PhxToaster', PhxToaster);
const instance = app.mount('#phoenix-toaster');
Phoenix.toaster = instance.$refs.toasterRef;
